var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { gql, useApolloClient } from "@apollo/client";
import { useSaveSubscriptionOrWelcomeGiftOrDriveBenefitMutation, SaveSubscriptionBenefitFragmentDoc, SaveWelcomeGiftBenefitFragmentDoc, SaveDriveBenefitFragmentDoc, useUpdateBusinessMutation } from "../types";
import { prepareSubscriptionBenefitInput, calculateDefaultCurationValue } from '@withfriendsco/wf-components';
gql `
fragment SaveSubscriptionBenefit on SubscriptionBenefit {
  business {
    id 
    enableAutomatedCuration
    enableProductSwapping
    includeWelcomeGiftInFirstShipment
  }
  name
  shippingNotesInstructions
  nextShipmentDate
  delivery
  deliveryFrequency
  shippingEnabled
  pickupEnabled
  shippingCost {
    amount
  }
  shippingFrequency {
    period
    number
  }
  firstShipmentDelay
  isAddonOnly
  products {
    id
    name
    platformId
    platformName
    platformVariantsOnlyMode
    curationValue
    curationCollections
    curationExcludeProducts
    variants {
      id
      description
      additionalCost {
        amount
      }
      platformName
      platformId
      curationExcludeProducts
      curationIncludeVariants
      curationSearchTerms
      curationStatus
      curationError
      flagReason
    }
  }
  variants {
    id
    description
    additionalCost {
      amount
    }
    platformName
    platformId
  }
  addons {
    id
    description
    applyDiscount
    dontRollOver
    platformId
    platformName
    additionalCost {
      amount
    }
  }
  curationMatchMode
  curationPreferOverstock
  membershipTiers {
    plans { 
      kind
      price {
        amount
      }
    }
  }
}

fragment SaveWelcomeGiftBenefit on WelcomeGiftBenefit {
  business {
    id 
    includeWelcomeGiftInFirstShipment
    enableAutomatedCuration
    enableProductSwapping
  }
  shippingEnabled
  pickupEnabled
  shippingCost {
    amount
  }
  name
  shippingNotesInstructions
  delivery
  products {
    id
    name
    platformId
    platformName
    platformVariantsOnlyMode
    variants {
      id
      description
      additionalCost {
        amount
      }
      platformName
      platformId
    }
  }
  variants {
    id
    description
    additionalCost {
      amount
    }
    platformName
    platformId
  }
}

fragment SaveDriveBenefit on DriveBenefit {
  business {
    id 
    includeWelcomeGiftInFirstShipment
    enableAutomatedCuration
    enableProductSwapping
  }
  shippingEnabled
  pickupEnabled
  shippingCost {
    amount
  }
  name
  shippingNotesInstructions
  products {
    id
    name
    platformId
    platformName
    platformVariantsOnlyMode
    variants {
      id
      description
      additionalCost {
        amount
      }
      platformName
      platformId
    }
  }
}


mutation SaveSubscriptionOrWelcomeGiftOrDriveBenefit($id: ID!, $benefit: BenefitInput!) {
  updateBenefit(id: $id, benefit: $benefit) {
    id
    name
    ...on SubscriptionBenefit {
      ...SaveSubscriptionBenefit
    }
    ...on WelcomeGiftBenefit {
      ...SaveWelcomeGiftBenefit
    }
    ...on DriveBenefit {
      ...SaveDriveBenefit
    }
  }
}

`;
export const useSaveSubscriptionBenefit = (id, kind) => {
    const client = useApolloClient();
    const [saveBenefit, result] = useSaveSubscriptionOrWelcomeGiftOrDriveBenefitMutation();
    const [updateBusiness] = useUpdateBusinessMutation();
    const wrappedFunction = async (...args) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const benefit = client.readFragment({
            id: `${kind}:${id}`,
            fragment: kind == "SubscriptionBenefit" ? SaveSubscriptionBenefitFragmentDoc : kind == "WelcomeGiftBenefit" ? SaveWelcomeGiftBenefitFragmentDoc : SaveDriveBenefitFragmentDoc,
            fragmentName: kind == "SubscriptionBenefit" ? "SaveSubscriptionBenefit" : kind == "WelcomeGiftBenefit" ? "SaveWelcomeGiftBenefit" : "SaveDriveBenefit",
        });
        console.log(kind == "SubscriptionBenefit" ? SaveSubscriptionBenefitFragmentDoc : kind == "WelcomeGiftBenefit" ? SaveWelcomeGiftBenefitFragmentDoc : SaveDriveBenefitFragmentDoc);
        console.log("benefit", benefit);
        let defaultCurationValue = 0;
        if (kind == "SubscriptionBenefit") {
            const monthlyPrice = (_d = (_c = (_b = (_a = benefit === null || benefit === void 0 ? void 0 : benefit.membershipTiers[0]) === null || _a === void 0 ? void 0 : _a.plans) === null || _b === void 0 ? void 0 : _b.find(plan => plan.kind == "MONTHLY")) === null || _c === void 0 ? void 0 : _c.price) === null || _d === void 0 ? void 0 : _d.amount;
            if (monthlyPrice) {
                defaultCurationValue = calculateDefaultCurationValue((_e = benefit.shippingFrequency) === null || _e === void 0 ? void 0 : _e.period, benefit.deliveryFrequency, monthlyPrice);
            }
        }
        const benefitKey = benefit.__typename === "SubscriptionBenefit"
            ? "subscription"
            : benefit.__typename === "WelcomeGiftBenefit"
                ? "welcomeGift"
                : "drive";
        let benefitValue = prepareSubscriptionBenefitInput(benefit, benefit.business.enableAutomatedCuration, defaultCurationValue);
        if (benefitKey === "drive") {
            const { variants, shippingFrequency, delivery, deliveryFrequency, firstShipmentDelay } = benefitValue, restOfBenefitValue = __rest(benefitValue, ["variants", "shippingFrequency", "delivery", "deliveryFrequency", "firstShipmentDelay"]);
            benefitValue = restOfBenefitValue;
        }
        const variables = {
            id: id,
            benefit: {
                [benefitKey]: benefitValue
            }
        };
        const businessVariables = {
            id: benefit.business.id,
            business: kind == "SubscriptionBenefit" ? {
                enableAutomatedCuration: (_f = benefit === null || benefit === void 0 ? void 0 : benefit.business) === null || _f === void 0 ? void 0 : _f.enableAutomatedCuration,
                enableProductSwapping: (_g = benefit === null || benefit === void 0 ? void 0 : benefit.business) === null || _g === void 0 ? void 0 : _g.enableProductSwapping,
            } : {
                includeWelcomeGiftInFirstShipment: (_h = benefit === null || benefit === void 0 ? void 0 : benefit.business) === null || _h === void 0 ? void 0 : _h.includeWelcomeGiftInFirstShipment
            }
        };
        await updateBusiness({ variables: businessVariables });
        return saveBenefit(Object.assign(Object.assign({}, args), { variables: variables, update: (cache, { data: { updateBenefit } }) => {
                if (updateBenefit.__typename === "SubscriptionBenefit")
                    cache.modify({
                        id: `SubscriptionBenefit:${updateBenefit.id}`,
                        fields: {
                            name: () => updateBenefit.name
                        }
                    });
                else if (updateBenefit.__typename === "WelcomeGiftBenefit")
                    cache.modify({
                        id: `WelcomeGiftBenefit:${updateBenefit.id}`,
                        fields: {
                            name: () => updateBenefit.name
                        }
                    });
                else if (updateBenefit.__typename === "DriveBenefit")
                    cache.modify({
                        id: `DriveBenefit:${updateBenefit.id}`,
                        fields: {
                            name: () => updateBenefit.name
                        }
                    });
            } }));
    };
    return {
        wrapped: wrappedFunction,
        original: saveBenefit,
        result,
    };
};
